/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import VPagination from "@hennge/vue3-pagination";
import Multiselect from "@vueform/multiselect";

export default {
  name: "labValidationRule",
  components: {
    customModal,
    VPagination,
    Multiselect
  },
  emits: ["closeModal", "showSetVersion"],
  props: {
    id: {
      type: String,
      default: "",
    },
    showSetRange: {
      type: Boolean,
      default: false,
    },
    labCode: {
      type: String,
      default: "",
    },
    testCode: {
      type: String,
      default: "",
    },
    unitselected: {
      type: String,
      default: "",
    },
    ruleName: {
      type: String,
      default: "",
    },
    ruleCode: {
      type: String,
      default: "",
    },
    gender: {
      type: String,
      default: ""
    },
    ageMin: {
      type: Number,
      default: null
    },
    ageMax: {
      type: Number,
      default: null
    },
    versionNo: {
      type: String,
      default: "",
    },
    referenceRangeId: {
      type: String,
      default: "",
    },
    cdiscVariable: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      showLoading: false,
      labList: [],
      compareTo: "",
      totalItems: 0,
      severity: "",
      selectedVersion: "",
      showAddRangeVersionModal: false,
      showAddValidationRuleModal: false,
      effectiveDate: new Date().toISOString(),
      isActive: true,
      studyId: "",
      versionList: [],
      SortOrder: 0,
      isAutoGeneratedQuery: false,
      SortProperty: "",
      currentPage: 1,
      localRuleCode: "",
      localTestCode: "",
      localLabCode: "",
      localVersionNo: "",
      localReferenceRangeId: "",
      ageErrors: [false, false, false],
      rangeErrors: [false, false, false],
      isEditing: false,
      alertType: "",
      alertCategories: [],
      alertError: false,
      loadingValidationRule: false,
      isVersionLocked: false,
      editingId: null,

      ruleCodeForm: "",
      ruleNameForm: "",
      description: "",
      operator: "",
      thresholdValue: "",
      actionType: "",
      actionMessage: "",
      visit: "",

      localGender: "",
      localAgeMin: null,
      localAgeMax: null,
      minRange: null,
      maxRange: null,
      multiNotificationSelect: [],
      multiRoleSelectList: [],
      rolesToNotify: [],
      userList: [],
      roleList: [],
      showRoleAndEmailFields: false,
      emailRecipients: [],

      rangeSeverity: "",
      errors: {
        ruleCode: false,
        ruleName: false,
        severity: false,
        operator: false,
        thresholdValue: false,
        actionType: false,
        actionMessage: false,
        ageRange: false,
        compareTo: false,
      },

      errorMessages: {
        ruleCode: '',
        ruleName: '',
        severity: '',
        operator: '',
        thresholdValue: '',
        actionType: '',
        actionMessage: '',
        ageRange: '',
        alertType: false,
        compareTo: ''
      },
    };
  },

  watch: {
    gender: {
      immediate: true,
      handler(newVal) {
        this.localGender = newVal;
      }
    },
    ageMin: {
      immediate: true,
      handler(newVal) {
        this.localAgeMin = newVal;
      }
    },
    ageMax: {
      immediate: true,
      handler(newVal) {
        this.localAgeMax = newVal;
      }
    },
    versionNo: {
      immediate: true,
      handler(newVal) {
        this.localVersionNo = newVal;
      }
    },
    referenceRangeId: {
      immediate: true,
      handler(newVal) {
        this.localReferenceRangeId = newVal;
      }
    },
    multiRoleSelectList: {
      handler(newVal) {
        this.getRoleBasedUserlist();
      },
      deep: true
    }
  },

  async mounted() {
    console.log("cdiscVariable in labvalidationrule", this.cdiscVariable);
    console.log("TestCode", this.testCode);
    this.ruleCodeForm = this.ruleCode || "";
    this.ruleNameForm = this.ruleName || "";
    this.token = store.getters.getIdToken;
    this.studyId = store.getters.getStudyIs;

    this.localRuleCode = this.ruleCode || "";
    this.localTestCode = this.testCode || "";
    this.localLabCode = this.labCode || "";
    this.unit = this.unitselected || "";
    this.localGender = this.gender || "";
    console.log("gender is", this.gender)
    this.localAgeMin = this.ageMin;
    this.localAgeMax = this.ageMax;
    this.localVersionNo = this.versionNo || "";
    this.localReferenceRangeId = this.referenceRangeId || "";

    await this.listLabTestRanges();
    await this.setRoleList();
    await this.getAlertCategories();
  },

  methods: {
    closeValidationRule() {
      this.showAddValidationRuleModal = false;
      this.resetForm();
    },
    closeValidation() {
      this.$emit("closeModal");
    },
    clearErrors() {
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = false;
      });
      Object.keys(this.errorMessages).forEach(key => {
        this.errorMessages[key] = '';
      });
    },
    async getAlertCategories() {
      try {
        const idtoken = store.getters.getIdToken;
        const response = await axios.get(
          `${this.baseurl}/forms/alert/getalertcategorys`,
          {
            headers: {
              Authorization: "Bearer " + idtoken
            }
          }
        );
        this.alertCategories = response.data.entities.map(item => item.category).sort((a, b) => a.localeCompare(b));
      } catch (error) {
        console.error("Error fetching alert categories:", error);
        this.alertCategories = [];
      }
    },

    async listLabTestRanges() {
      this.showLoading = true;

      const labCode = this.localLabCode || this.labCode || "";
      const testCode = this.localTestCode || this.testCode || "";
      const studyId = this.studyId || "";
      const referenceRangeId = this.localReferenceRangeId || this.referenceRangeId || "";
      const versionNo = this.localVersionNo || this.versionNo || "";

      try {
        const response = await axios.get(`${this.baseurl}/management/labvalidationrule/listlabvalidation?LabCode=${encodeURIComponent(labCode)}&TestCode=${encodeURIComponent(testCode)}&StudyId=${encodeURIComponent(studyId)}&ReferenceRangeId=${encodeURIComponent(referenceRangeId)}&VersionNo=${encodeURIComponent(versionNo)}`,

          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          });

        const data = response.data || {};

        if (Array.isArray(data.results)) {
          this.labList = data.results.map((item) => {
            console.log("Processing item:", item);
            return {
              id: item.id || `${item.ruleCode}-${item.testCode}`,
              ruleCode: item.ruleCode || "",
              ruleName: item.ruleName || "",
              testCode: item.testCode || "",
              severity: item.severity || "",
              description: item.description || "",
              operator: item.condition?.operator || "",
              thresholdValue: item.condition?.thresholdValue || "",
              actionType: item.action?.type || "",
              actionMessage: item.action?.message || "",
              versionNo: item.versionNo || "",
              compareTo: item.condition?.compareTo || "",
              referenceRangeId: referenceRangeId,
              isActive: item.isActive !== undefined && item.isActive !== null ? item.isActive : true,
              raw: item,
            };
          });
          console.log("Processed labList:", this.labList);
        } else {
          this.labList = [];
          console.log("No results array in response");
        }

        const pageSize = 10;
        this.totalItems = Math.ceil((data.totalCount || this.labList.length) / pageSize);
        console.log("Total items:", this.totalItems, "Lab list length:", this.labList.length);

      } catch (err) {
        console.error("Error fetching lab validation rules:", err);
        console.error("Error details:", err.response?.data);
        this.labList = [];
        this.totalItems = 0;
      } finally {
        this.showLoading = false;
      }
    },

    async sortVersions(results) {
      const versionSet = new Set(
        (results || []).map((item) => item.versionNo?.toString().trim()).filter((v) => v)
      );
      const sorted = Array.from(versionSet).sort((a, b) => {
        const numA = parseFloat(a);
        const numB = parseFloat(b);
        if (!isNaN(numA) && !isNaN(numB)) return numB - numA;
        return b.localeCompare(a, undefined, { numeric: true, sensitivity: "base" });
      });
      return sorted;
    },

    async getLabMaster() {
      await this.listLabTestRanges();
    },

    async showAddRangeModal() {
      this.resetForm();
      this.isVersionLocked = false;
      this.localLabCode = this.labCode || this.localLabCode;
      this.localTestCode = this.testCode || this.localTestCode;
      this.ruleCodeForm = this.ruleCode || "";
      this.ruleNameForm = this.ruleName || "";
      this.localGender = this.gender || "";
      this.localAgeMin = this.ageMin !== null && this.ageMin !== undefined ? this.ageMin : null;
      this.localAgeMax = this.ageMax !== null && this.ageMax !== undefined ? this.ageMax : null;

      this.showAddValidationRuleModal = true;
      await this.listLabTestRanges();
    },
    async saveValidationRule() {
      const ok = this.validate();
      if (!ok) return;

      this.loadingValidationRule = true;
      const idtoken = store.getters.getIdToken;

      const payload = {
        createdUserEmail: store.getters.getUserEmail || "",
        createdUserId: store.getters.getUserId || "",
        createdAt: new Date().toISOString(),
        lastModifiedUserEmail: store.getters.getUserEmail || "",
        lastModifiedUserId: store.getters.getUserId || "",
        lastModifiedAt: new Date().toISOString(),
        referenceRangeId: this.localReferenceRangeId || this.referenceRangeId || "",
        labCode: this.localLabCode || this.labCode || "",
        ruleCode: (this.ruleCodeForm || this.localRuleCode || "").trim(),
        ruleName: (this.ruleNameForm || "").trim(),
        testCode: this.localTestCode || this.testCode || "",
        cdiscVariable: this.cdiscVariable || "",
        description: this.description || "",
        condition: {
          operator: this.operator || "",
          compareTo: this.compareTo || "",
          thresholdValue: this.thresholdValue || ""
        },
        action: {
          type: "Information",
          message: this.actionMessage || ""
        },
        severity: this.severity || "",
        scope: {
          studyId: this.studyId || "",
          visit: this.visit || "",
          labCode: this.localLabCode || "",
          gender: this.localGender || "",
          ageMin: this.localAgeMin !== null && this.localAgeMin !== undefined ? Number(this.localAgeMin) : null,
          ageMax: this.localAgeMax !== null && this.localAgeMax !== undefined ? Number(this.localAgeMax) : null
        },
        isActive: this.isActive === undefined ? true : !!this.isActive,
        versionNo: this.localVersionNo || this.versionNo || "",
        studyId: this.studyId || "",
        alertType: this.alertType || "",
        isAutoGeneratedQuery: !!this.isAutoGeneratedQuery,
        notificationMethod: Array.isArray(this.multiNotificationSelect) ? this.multiNotificationSelect : [],
        notificationEmail: Array.isArray(this.emailRecipients) ? this.emailRecipients : [],
        rolesToNotify: Array.isArray(this.multiRoleSelectList) ? this.multiRoleSelectList : [],
      };

      console.log("Payload being sent:", payload);

      try {
        if (this.isEditing && this.editingId) {
          payload.valId = this.editingId;
          await axios.put(`${this.baseurl}/management/labvalidationrule/update`, payload, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          });
          alert(this.$t("navigations.validation rule updated successfully"));
        } else {
          await axios.post(`${this.baseurl}/management/labvalidationrule/create`, payload, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          });
          alert(this.$t("navigations.validation rule created successfully"));
        }

        await this.listLabTestRanges();
        this.$emit("showSetVersion", true);
        this.resetForm();
        this.showAddValidationRuleModal = false;
      } catch (err) {
        console.error("Save validation rule failed:", err);
        alert(err.response?.data?.detail || err.response?.data?.message || "Save operation failed");
      } finally {
        this.loadingValidationRule = false;
      }
    },
    async deleteLabs(id) {
      if (!confirm(this.$t("navigations.are you sure you want to delete this lab reference range?")))
        return;

      try {
        const response = await axios.delete(
          `${this.baseurl}/management/labvalidationrule/delete?ID=${id}`,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200 || response.status === 204) {
          alert(this.$t("navigations.validation rule deleted successfully"));
          await this.listLabTestRanges();
        } else {
          console.warn("Unexpected response:", response);
          alert("Delete may not have completed successfully");
        }
      } catch (err) {
        console.error("Delete error:", err);
        alert(err.response?.data?.detail || "Delete failed");
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      return date.toLocaleDateString();
    },

    handleCompareToChange() {
      if (this.compareTo === 'Min-Max') {
        this.operator = 'BETWEEN';
        this.thresholdValue = '';
      } else {
        if (this.operator === 'BETWEEN') {
          this.operator = '';
        }
        this.thresholdValue = '';
      }
    },
    validate() {
  this.clearErrors();
  let isValid = true;

  if (!this.ruleCodeForm.trim()) {
    this.errors.ruleCode = true;
    this.errorMessages.ruleCode = this.$t("navigations.please enter a rule code");
    isValid = false;
  }

  if (!this.ruleNameForm.trim()) {
    this.errors.ruleName = true;
    this.errorMessages.ruleName = this.$t("navigations.please enter a rule name");
    isValid = false;
  }

  if (!this.alertType) {
    this.errors.alertType = true;
    this.errorMessages.alertType = this.$t("navigations.please choose a value");
    isValid = false;
  }

  if (!this.severity) {
    this.errors.severity = true;
    this.errorMessages.severity = this.$t("navigations.please select severity");
    isValid = false;
  }

  if (!this.compareTo) {
    this.errors.compareTo = true;
    this.errorMessages.compareTo = this.$t("navigations.please select compareto");
    isValid = false;
  }

  if (!this.operator) {
    this.errors.operator = true;
    this.errorMessages.operator = this.$t("navigations.please select operator");
    isValid = false;
  }

  if (this.compareTo === "Custom" && !this.thresholdValue) {
    this.errors.thresholdValue = true;
    this.errorMessages.thresholdValue = this.$t("navigations.please enter threshold value");
    isValid = false;
  }

  if (!this.actionMessage.trim()) {
    this.errors.actionMessage = true;
    this.errorMessages.actionMessage = this.$t("navigations.please enter action message");
    isValid = false;
  }

  if (
    this.localAgeMin !== null &&
    this.localAgeMax !== null &&
    this.localAgeMax < this.localAgeMin
  ) {
    this.errors.ageRange = true;
    this.errorMessages.ageRange = this.$t("navigations.max age cannot be less than min age");
    isValid = false;
  }

  if (!this.multiNotificationSelect || this.multiNotificationSelect.length === 0) {
    this.errors.notificationMethod = true;
    this.errorMessages.notificationMethod = this.$t("navigations.please choose a value");
    isValid = false;
  }

  const hasEmailOrQueryNotification = 
    this.multiNotificationSelect.includes("Email Notification") || 
    this.multiNotificationSelect.includes("Query Notification");

  if (
    hasEmailOrQueryNotification &&
    (!this.multiRoleSelectList || this.multiRoleSelectList.length === 0)
  ) {
    this.errors.roles = true;
    this.errorMessages.roles = this.$t("navigations.please choose a value");
    isValid = false;
  }

  if (
    hasEmailOrQueryNotification &&
    (!this.emailRecipients || this.emailRecipients.length === 0)
  ) {
    this.errors.emailRecipients = true;
    this.errorMessages.emailRecipients = this.$t("navigations.please choose a value");
    isValid = false;
  }

  return isValid;
},

    resetForm() {
      this.localGender = this.gender || "";
      this.localAgeMin = null;
      this.localAgeMax = null;
      this.ruleCodeForm = "";
      this.ruleNameForm = "";
      this.description = "";
      this.operator = "";
      this.thresholdValue = "";
      this.actionType = "";
      this.actionMessage = "";
      this.visit = "";
      this.severity = "";
      this.alertType = "";
      this.compareTo = "";
      this.localTestCode = this.testCode || "";
      this.localLabCode = this.labCode || "";
      this.multiNotificationSelect = [];
      this.multiRoleSelectList = [];
      this.emailRecipients = [];
      this.userList = [];
      this.showRoleAndEmailFields = false;
      this.isAutoGeneratedQuery = false;
      this.isEditing = false;
      this.editingId = null;
    },

    async editlabtest(id) {
      this.isEditing = true;
      this.editingId = id;
      this.showAddValidationRuleModal = true;
      await this.bindValidation();
    },

    async bindValidation() {

      try {
        const response = await axios.get(
          `${this.baseurl}/management/labvalidationrule/getbyid?id=${this.editingId}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const record = response.data;

        if (!record) {
          alert("No record found for this ID.");
          return;
        }

        this.ruleCodeForm = record.ruleCode || "";
        this.ruleNameForm = record.ruleName || "";
        this.description = record.description || "";
        this.severity = record.severity || "";
        this.localVersionNo = record.versionNo || "";

        this.isActive =
          record.isActive !== undefined && record.isActive !== null
            ? record.isActive
            : true;

        this.operator = record.condition?.operator || "";
        this.compareTo = record.condition?.compareTo || "";
        this.thresholdValue = record.condition?.thresholdValue || "";

        this.actionType = "Information";
        this.actionMessage = record.action?.message || "";

        this.studyId = record.scope?.studyId || this.studyId;
        this.localLabCode = record.scope?.labCode || this.localLabCode || "";
        this.localTestCode = record.testCode || this.localTestCode || "";
        this.localGender = record.scope?.gender || this.gender || "";

        this.localAgeMin =
          record.scope?.ageMin !== undefined && record.scope?.ageMin !== null
            ? record.scope.ageMin
            : this.ageMin;

        this.localAgeMax =
          record.scope?.ageMax !== undefined && record.scope?.ageMax !== null
            ? record.scope.ageMax
            : this.ageMax;

        this.visit = record.scope?.visit || "";
        this.alertType = record.alertType || "";
        this.isAutoGeneratedQuery =
          record.isAutoGeneratedQuery !== undefined && record.isAutoGeneratedQuery !== null
            ? record.isAutoGeneratedQuery
            : false;

        this.multiNotificationSelect = Array.isArray(record.notificationMethod)
          ? record.notificationMethod
          : [record.notificationMethod].filter(Boolean);

        this.emailRecipients = Array.isArray(record.notificationEmail)
          ? record.notificationEmail
          : [];

        this.multiRoleSelectList = Array.isArray(record.rolesToNotify)
          ? record.rolesToNotify
          : [];
        this.localReferenceRangeId = record.referenceRangeId || "";
      this.showRoleAndEmailFields = 
      this.multiNotificationSelect.includes('Email Notification') || 
      this.multiNotificationSelect.includes('Query Notification');
        console.log("Editing validation rule - Condition data:", {
          operator: this.operator,
          compareTo: this.compareTo,
          thresholdValue: this.thresholdValue,
          condition: record.condition,
          versionNo: this.localVersionNo,
        });

      } catch (err) {
        console.error("Error fetching record by ID:", err.response || err);
        alert("Failed to load validation rule for editing");
      }
    },

    onNotificationMethodChange(selectedValues) {

      this.showRoleAndEmailFields = selectedValues.includes('Email Notification');
      this.isAutoGeneratedQuery = selectedValues.includes("Query Notification");


      if (!this.showRoleAndEmailFields) {
        this.onClear();
      }
    },


    onClear() {
      this.multiRoleSelectList = [];
      this.emailRecipients = [];
      this.userList = [];
    },
    onRecipientClear() {
      this.emailRecipients = [];
    },

    onRoleSelect(selectedRole, roleId) {
      this.getRoleBasedUserlist();
    },

    onRoleDeselect(deselectedRole, roleId) {
      this.getRoleBasedUserlist();
    },
    async getRoleBasedUserlist() {
      if (Array.isArray(this.multiRoleSelectList) && this.multiRoleSelectList.length > 0) {
        const fullroleids = this.multiRoleSelectList.join(',');
        try {
          const response = await axios.get(
            `${this.baseurl}/account-core/user/getusersbyrole?roleids=${fullroleids}&studyid=${this.studyId}`,
            {
              headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
              },
            }
          );
          this.userList = response.data || [];
        } catch (err) {
          console.error("Error fetching users by role:", err);
          this.userList = [];
        }
      } else {
        this.userList = [];
        this.emailRecipients = [];
      }
    },

    onSelectClosed() {
      this.getRoleBasedUserlist();
    },

    async setRoleList() {
      try {
        const response = await axios.get(
          `${this.baseurl}/account-core/roles/rolelist`,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );
        this.roleList = response.data || [];
      } catch (err) {
        console.log("Error fetching role list:", err);
        this.roleList = [];
      }
    },
  },
};